<!-- Button -->
<button mat-icon-button [matTooltip]="tooltip || 'Search Launcher'" (click)="toggleSearchLauncher()">
    <ng-container [ngTemplateOutlet]="iconTpl || defaultIconTpl"></ng-container>
</button>

<!-- Default icon -->
<ng-template #defaultIconTpl>
    <mat-icon [svgIcon]="'heroicons_outline:cursor-click'"></mat-icon>
</ng-template>